import EasyIcon from '../icons/easy.svg'
import MediumIcon from '../icons/medium.svg'
import HardIcon from '../icons/hard.svg'

const ICON = {
  1: EasyIcon,
  2: MediumIcon,
  3: HardIcon,
}

const TEXT = {
  1: window.gettext('easy'),
  2: window.gettext('medium'),
  3: window.gettext('hard'),
}

export const DifficultText = (props) => {
  const { value } = props
  return TEXT[value]
}

export const DifficultIcon = (props) => {
  const { value } = props
  const text = `${window.gettext('difficult')} ${DifficultText(props)}`
  return ICON[value]({title: text})
}
